import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=051b61f2&"
import script from "./site-footer.vue?vue&type=script&lang=js&"
export * from "./site-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports